export default __webpack_public_path__ + "30a39d5f4f67ccc65e23906e6ecb33ad.png";